// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

// export const GOOGLE_CLIENT_ID = '466208940759-ohnagdutno0n98fvrl0nakc308mkm1k5.apps.googleusercontent.com'
export const GOOGLE_CLIENT_ID = '564755449617-5i3s5o74ajpu38dl0nt7oj0lv7q91rnp.apps.googleusercontent.com'

export const DOWNLOAD_TASK_TYPE = {
  DEVICE: 0,
  ROAD: 1,
  GEOFENCE: 2
}

export const DOWNLOAD_TASK_NAME = {
  [DOWNLOAD_TASK_TYPE.DEVICE]: 'CAMERA-SINGLE',
  [DOWNLOAD_TASK_TYPE.ROAD]: 'Road',
  [DOWNLOAD_TASK_TYPE.GEOFENCE]: 'GeoFence'
}

export const TASK_TYPE_SECTIONS = [
  DOWNLOAD_TASK_TYPE.DEVICE,
  DOWNLOAD_TASK_TYPE.ROAD,
  DOWNLOAD_TASK_TYPE.GEOFENCE
]

export const JOB_STATUS = {
  PENDING: 0,
  PROCESSING: 1,
  SUCCESSFUL: 2,
  FAILED: 3,
  DUE: 4,
  DISABLED: 5
}

export const DEFAULT_CITY = {
  id: 10,
  country_id: 6,
  country_code: 'ID',
  name: 'Jakarta',
  code: 'CGK',
  latitude: -6.211594,
  longitude: 106.845253,
  time_zone: 'Asia/Jakarta',
  enable_tip: true
}

export let SERVICE_ID = 15
export function setServiceId (id) {
  SERVICE_ID = id
}
